import React from 'react';
import ReadyToStart from '../../components/ReadyToStart';
import Intro from './Intro';
import Details from './Details';
import Feedbacks from './Feedbacks';
import Features from './Features';
import ValidatedBanner from './ValidatedBanner';

const Home = () => (
  <>
    <Intro />
    <ValidatedBanner />
    <Details />
    <Features />
    <Feedbacks />
    <ReadyToStart />
  </>
);

export default Home;
